import React, { useState, useEffect, useLayoutEffect } from 'react';

// 다국어
import { useTranslation } from 'react-i18next';
// @mui
import { styled } from '@mui/material/styles';
import axios from 'axios';

import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  InputLabel,
  TextField,
} from '@mui/material';
// components
import Label from '../label';
import Iconify from '../iconify';
import Scrollbar from '../scrollbar';
import ProfileComponent from './ProfileComponent';

// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
// mock
// import USERLIST from '../../_mock/user';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px',
}));

const StyledDiv2 = styled('div')(() => ({
  backgroundColor: 'white',
  marginRight: '40px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '10px',
  width: '20rem',
  height: '21rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

const StyledDiv3 = styled('div')(() => ({
  backgroundColor: 'white',
  padding: '56px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '10px',
  flex: 1,
  '& h2': {
    marginBottom: '40px',
  },
}));

// #################################################################################################

export default function ComposeGroup({ data }) {
  // 다국어
  const { t, i18n } = useTranslation(['page']);

  const TABLE_HEAD = [
    { id: 'role', label: t('권한'), alignRight: false },
    { id: 'name', label: t('이름'), alignRight: false },
    // { id: 'company', label: 'Company', alignRight: false },
    { id: 'createDate', label: t('등록일'), alignRight: false },
    // { id: 'isVerified', label: 'Verified', alignRight: false },
    { id: 'lastLogin', label: t('마지막 로그인'), alignRight: false },
    { id: 'status', label: t('상태'), alignRight: false },
    { id: '' },
  ];

  const UserData = data;

  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  // console.log("asdasd", JSON.parse(sessionStorage.getItem('login_info')))
  const userToken = JSON.parse(sessionStorage.getItem('login_info')).user_token;

  const [orgToken, setOrgToken] = useState('');

  const [USERLIST, setUserList] = useState([]);

  const [inputInviteUserEmail, setinputInviteUserEmail] = useState('');
  const [inputUserId, setInputUserId] = useState('');

  const [loading, setLoading] = useState(false);
  const [availableAccountCount, setAvailableAccountCount] = useState(0);
  // JSON.parse(sessionStorage.getItem('login_info')).user_name

  const fetchData = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/org-list/${userToken}`,
        method: 'post',
      });

      // console.log("data",response.data[0][0]);
      const newUserList = [];

      for (let i = 0; i < response.data[0].length; i += 1) {
        newUserList.push({
          id: response.data[0][i].user_token,
          name: response.data[0][i].user_name,
          company: response.data[0][i].company,
          isVerified: false,
          status: response.data[0][i].status,
          role: response.data[0][i].authority,
          createdDate: response.data[0][i].created_at,
          lastLogin: response.data[0][i].last_login,
        });
      }

      setOrgToken(response.data[0][0].organization_id);
      setUserList(newUserList);

      // 라이센스 타입별 사용횟수 검색
      axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/license-type/${response.data[0][0].license_type}`,
        method: 'post',
      })
        .then((response) => {
          // console.log("라이센스 타입 response", response.data[0][0])
          if (Object.prototype.hasOwnProperty.call(response.data[0][0], 'license_type_setting_json')) {
            // console.log("라이센스 타입 json ", response.data[0][0])
            console.log('라이센스 타입 response', JSON.parse(response.data[0][0].license_type_setting_json));
            setAvailableAccountCount(JSON.parse(response.data[0][0].license_type_setting_json).account_cnt);
            // setLicenseTypeUseInfo(JSON.parse(response.data[0][0].license_type_setting_json));
          }
        })
        .catch((response) => {
          console.log(response);
        });
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData();
  }, []);

  //  console.log("data",USERLIST.length);

  const handleinputInviteUserEmail = (e) => {
    setinputInviteUserEmail(e.target.value);
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setInputUserId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const inviteUserClick = (event) => {
    if (USERLIST.length >= availableAccountCount) {
      alert('추가할 수 있는 인원수를 초과했습니다.');
    } else if (inputInviteUserEmail !== null && inputInviteUserEmail !== '') {
      setLoading(true);
      const sendData = {
        org_token: orgToken,
        user_token: inputInviteUserEmail,
        org_user_authority: 'USER',
        org_user_status: 0,
      };

      console.log('sendData', sendData);
      axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/org-invite`,
        method: 'post',
        data: sendData,
      })
        .then((response) => {
          console.log('response', response.data[0][0].result);
          const params = {
            to_email: inputInviteUserEmail,
            subject: '레인드롭 초대 메일',
            html: `<div style='padding:30px;width:700px'>
                    <div style='border-top:7px solid #07a2e8;border-bottom: 2px solid #d2d2d2;padding:50px 0 80px 0'>
                        <h3 style='font-size: 48px;font-weight: 400;color: #07a2e8;'>레인드롭 그룹원 초대 메일</h3>
                        <p style='margin-top:80px; font-size:24px'>${UserData.user_name}님이 레인드롭 그룹에 초대했습니다.<br>
                        아래 링크를 통해 접속하세요.</p>
                    </div>
                    <p style='padding:10px 30px;border:1px solid #07a2e8;border-radius: 5px;font-size:18px;margin:40px auto 0 auto;width: 200px;color: #07a2e8;text-align: center;font-size: 36px;font-weight: 400;'><a href='http://raindrop.sugarpole.com/login?invite_token=${response.data[0][0].temporary_id}'>링크</p>
                </div>`,
          };
          switch (response.data[0][0].result) {
            case 'already invited':
              alert('이미 초대된 사용자입니다.');
              break;
            case 'not allowed':
              alert('초대받을 수없는 사용자입니다.');
              break;
            case 'success':
              axios({
                url: `${process.env.REACT_APP_SERVER_URL}/user/email`,
                method: 'post',
                data: params,
              })
                .then((response) => {
                  console.log('email response', response.data);
                  if (response.data.result === 'success') {
                    alert(`${inputInviteUserEmail} 님에게 초대 메일을 전송했습니다.`);
                  }
                  setinputInviteUserEmail('');
                  fetchData();

                  setLoading(false);
                })
                .catch((error) => {
                  console.log('error', error);
                  setinputInviteUserEmail('');
                  fetchData();
                  setLoading(false);
                });
              break;
            default:
              break;
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    } else {
      alert('이메일을 입력해주세요.');
    }
  };

  const handleDelete = (event) => {
    if (window.confirm('정말 삭제하시겠어요?')) {
      // console.log("User token", inputUserId);
      const sendData = {
        org_token: orgToken,
        user_token: inputUserId,
        org_user_authority: 'USER',
        org_user_status: 3,
      };

      console.log('sendData', sendData);
      axios({
        url: `${process.env.REACT_APP_SERVER_URL}/user/org-invite`,
        method: 'post',
        data: sendData,
      })
        .then((response) => {
          console.log('response', response.data[0][0].result);
          fetchData();
        })
        .catch((error) => {
          console.log('error', error);
        });
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <div style={{ display: 'flex', padding: '0 10%' }}>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <StyledDiv>
            <StyledDiv2>
              <ProfileComponent data={UserData} />
            </StyledDiv2>
            <StyledDiv3>
              <h2>{t('조직 구성')}</h2>
              <Card style={{ overflow: 'auto' }}>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={USERLIST.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {filteredUsers.map((row) => {
                        const { id, name, role, status, avatarUrl, createdDate, lastLogin } = row;
                        const selectedUser = selected.indexOf(name) !== -1;

                        return (
                          <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                            <TableCell align="left">
                              {' '}
                              <Label color={(role === 'USER' && 'default') || 'primary'}>{role}</Label>
                            </TableCell>

                            <TableCell align="left">{name}</TableCell>

                            {<TableCell align="left">{createdDate}</TableCell>}
                            {<TableCell align="left">{(lastLogin === null && '-') || lastLogin}</TableCell>}
                            {
                              <TableCell align="left">
                                <Label color={(status === 1 && 'success') || 'warning'}>
                                  {(status === 1 && t('사용중')) || t('초대')}
                                </Label>
                                {/* color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error']) */}
                              </TableCell>
                            }
                            {role === 'USER' ? (
                              <TableCell align="right">
                                <IconButton size="large" id={id} color="inherit" onClick={handleOpenMenu}>
                                  <Iconify icon={'eva:more-vertical-fill'} />
                                </IconButton>
                              </TableCell>
                            ) : null}
                          </TableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isNotFound && (
                      <TableBody>
                        utUserEmail
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                Not found
                              </Typography>

                              <Typography variant="body2">
                                No results found for &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                                <br /> Try checking for typos or using complete words.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <TextField
                  style={{ flex: 1, marginRight: '10px' }}
                  sx={{
                    minWidth: 800,
                  }}
                  id="invite-user-email"
                  value={inputInviteUserEmail}
                  onChange={handleinputInviteUserEmail}
                  label={t('이메일 주소를 입력하세요.')}
                  variant="outlined"
                />
                <LoadingButton
                  onClick={inviteUserClick}
                  endIcon={<SendIcon />}
                  loading={loading}
                  loadingPosition="end"
                  variant="contained"
                >
                  <span>{t('구성원 초대하기')}</span>
                </LoadingButton>
                {/* <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={USERLIST.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
              </div>
              <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                  sx: {
                    p: 1,
                    width: 140,
                    '& .MuiMenuItem-root': {
                      px: 1,
                      typography: 'body2',
                      borderRadius: 0.75,
                    },
                  },
                }}
              >
                {/* <MenuItem>
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Edit
          </MenuItem> */}

                <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
                  <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                  삭제
                </MenuItem>
              </Popover>
            </StyledDiv3>
          </StyledDiv>
        </div>
      </div>
    </>
  );

  // const [users, setUsers] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  //     const userToken = "user_token";
  //     const orgToken = "ttt213241-1232-tests";

  //         const fetchUsers = async () => {
  //           try {
  //             // 요청이 시작 할 때에는 error 와 users 를 초기화하고
  //             setError(null);
  //             setUsers(null);
  //             // loading 상태를 true 로 바꿉니다.
  //             setLoading(true);

  //             const response = await axios({
  //                 url : `http://210.220.65.132:82/user/org-list/${userToken}/${orgToken}`,
  //                 method : 'post'
  //               });

  //               console.log('response', response.data[0]);

  //             setUsers(response.data[0]); // 데이터는 response.data 안에 들어있습니다.

  //           } catch (e) {
  //             setError(e);
  //           }
  //           setLoading(false);
  //         };

  //         useEffect(() => {
  //             fetchUsers();
  //           }, []);

  //       if (loading) return <div>로딩중..</div>;
  //       if (error) return <div>에러가 발생했습니다</div>;
  //       if (!users) return null;

  // return (
  //     <>
  //     <div>조직 구성</div>
  //     <ul>
  //         {users.map(user => (
  //             <li key={user.user_token}>
  //            authority : {user.authority} (status : {user.status}) name : {user.user_name}
  //             </li>
  //         ))}
  //     </ul>
  //     <button onClick={fetchUsers}>다시 불러오기</button>

  //     </>
  // );
}
